import React from 'react';

import { NextPage } from 'next';
import Head from 'next/head';

import { PageHeader } from '@utils/page-header';
import { messageIdConcat } from '@utils/message-id-concat';

import { Root } from '@modules/base';

import { EstimateLandingPageA } from './estimate-landing-page-a';

const m = messageIdConcat('estimate_landing_page');

export const EstimateLandingPage: NextPage = () => {
  return (
    <Root>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
      </Head>
      {/* Page header */}
      <PageHeader
        title={{ id: m('meta.title') }}
        ogTitle={{ id: m('meta.og_title') }}
        description={{ id: m('meta.description') }}
        ogDescription={{ id: m('meta.og_description') }}
        ogImage={require('@public/static/img/estimate-landing-page/jakou_hodnotu_má_vaše_nemovitost.png')}
      />
      <EstimateLandingPageA />
    </Root>
  );
};
